<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">On Beulah Height</h1>
<p class="subt">A Dalziel and Pascoe Mystery</p>
<p class="author">Reginald Hill</p>
<div class="img_container1">
<img alt="image" src="images/logo3.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?15b3f7de